module.exports = {
	"id": "PG",
	"name": "Papua New Guinea",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.004608,
			"11": 0.020736,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.004608,
			"16": null,
			"17": null,
			"18": 0.004608,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": 0.025344,
			"24": 0.002304,
			"25": 0.009216,
			"26": 0.052992,
			"27": 0.02304,
			"28": 0.004608,
			"29": 0.006912,
			"30": 0.002304,
			"31": 0.089856,
			"32": 0.009216,
			"33": 0.006912,
			"34": 0.004608,
			"35": 0.027648,
			"36": 0.029952,
			"37": 0.052992,
			"38": 0.006912,
			"39": 0.039168,
			"40": 0.032256,
			"41": 0.032256,
			"42": 0.025344,
			"43": 0.099072,
			"44": 0.03456,
			"45": 0.04608,
			"46": 0.135936,
			"47": 0.02304,
			"48": 0.029952,
			"49": 0.271872,
			"50": 0.108288,
			"51": 0.12672,
			"52": 0.232704,
			"53": 6.253056,
			"54": 1.596672,
			"55": 0.108288,
			"56": 0.016128,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.073728,
			"4": 0.013824,
			"5": 0.002304,
			"6": 0.004608,
			"7": 0.027648,
			"8": 0.020736,
			"9": null,
			"10": null,
			"11": 0.009216,
			"12": 0.020736,
			"13": 0.013824,
			"14": 0.002304,
			"15": 0.01152,
			"16": 0.004608,
			"17": 0.002304,
			"18": 0.006912,
			"19": 0.004608,
			"20": 0.002304,
			"21": null,
			"22": 0.009216,
			"23": null,
			"24": 0.004608,
			"25": 0.018432,
			"26": 0.013824,
			"27": 0.006912,
			"28": 0.076032,
			"29": 0.006912,
			"30": 0.013824,
			"31": 0.013824,
			"32": 0.048384,
			"33": 0.002304,
			"34": 0.039168,
			"35": 0.059904,
			"36": 0.009216,
			"37": 0.013824,
			"38": 0.04608,
			"39": 0.016128,
			"40": 0.078336,
			"41": 0.06912,
			"42": 0.013824,
			"43": 0.209664,
			"44": 0.112896,
			"45": 0.020736,
			"46": 0.200448,
			"47": 0.688896,
			"48": 0.396288,
			"49": 3.866112,
			"50": 0.124416,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.009216
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": 0.013824,
			"33": null,
			"34": 0.004608,
			"35": 0.01152,
			"36": 0.004608,
			"37": 0.052992,
			"38": 0.004608,
			"39": 0.004608,
			"40": 0.117504,
			"41": 0.006912,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.002304
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.013824,
			"6": 0.006912,
			"7": 0.013824,
			"8": 0.158976,
			"9": 0.03456,
			"10": 0.214272,
			"3.1": null,
			"3.2": null,
			"5.1": 0.032256,
			"6.1": 0.018432,
			"7.1": 0.01152,
			"9.1": 0.087552
		},
		"ios_saf": {
			"8": 0,
			"10": 0.499791440466,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0134688009992,
			"8.1-8.4": 0.0248830391341,
			"9.0-9.2": 0.0118708076603,
			"9.3": 0.18110591174
		},
		"android": {
			"3": 0,
			"4": 0.0510879173127,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00638598966408,
			"4.1": 0.184281416021,
			"4.2-4.3": 0.460703540052,
			"4.4": 1.05642514729,
			"4.4.3-4.4.4": 1.06554798966
		},
		"ie": {
			"6": null,
			"7": 0.00462079289284,
			"8": 0.639979815658,
			"9": 0.49673523598,
			"10": 0.268005987785,
			"11": 2.75168216768,
			"5.5": null
		},
		"op_mob": {
			"0": 0.320564856703,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00890457935285
		},
		"edge": {
			"12": 0.214272,
			"13": 0.223488,
			"14": 0.105984
		},
		"ie_mob": {
			"10": 0.0470431549296,
			"11": 0.19153284507
		},
		"bb": {
			"7": 0.013468,
			"10": null
		},
		"samsung": {
			"0": 1.316016
		},
		"and_uc": {
			"0": 60.436688
		},
		"op_mini": {
			"0": 4.31891456394
		},
		"and_chr": {
			"0": 7.725856
		},
		"and_ff": {
			"0": 0.007696
		}
	},
	"total": 99.473116
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PG.json
 ** module id = 620
 ** module chunks = 0
 **/